module.exports = __webpack_public_path__ + "img/svg/bizum.2b8fa76c5b75995ac419de3df5c250a4.svg";